<template>
  <div class="survey-detail">
    <ssurvey />
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'
import Ssurvey from '@/components/user-research/Survey'

export default {
  name: 'Survey',
  components: {
    Ssurvey
  },
  created () {
    EventBus.$emit('onLoading', false)
  }
}
</script>

<style lang="scss" scoped>
.survey-detail { }
</style>
